import { PageProvider } from '@/core/context/PageContext';
import { useEffect } from 'react';
import React from 'react';
import useViewModel from '../viewmodels/business-unit-list.viewmodel';
import GetAllBusinessUnitViewModel from '../viewmodels/business-unit-get-all.viewmodel';
import GetCategoryListViewModel from '../viewmodels/category-list.viewmodel';
import GetProductGroupListViewModel from '../viewmodels/product-group-list.viewmodel';
import { useTableFilter } from '@/core/hooks/useTableFilter';

export const BusinessUnitProvider = (props: any) => {
  const { businessUnitData, actionGetListBU, loading, error } = useViewModel();
  const { buData, actionGetAllBU } = GetAllBusinessUnitViewModel();
  const { categoryList, actionFindCategoryList } = GetCategoryListViewModel();
  const { productGroups, actionGetProductGroups } = GetProductGroupListViewModel();

  const { methodFilter } = useTableFilter({
    handleFetchData: actionGetListBU,
    querySearch: { search: '' },
    queryFilters: { status: undefined },
    queryPagination: { page: 1, limit: 10 },
  });

  const { control, setValue, reset, getValues, watch } = methodFilter;

  useEffect(() => {
    actionGetListBU(getValues());
    actionGetAllBU();
    actionFindCategoryList();
    actionGetProductGroups();
  }, []);

  const data = {
    businessUnitData,
    actionGetListBU,
    buData,
    businessUnitList: buData,
    actionGetAllBU,
    categoryList,
    actionFindCategoryList,
    productGroups,
    actionGetProductGroups,
    loading,
    error,
    control,
    setValue,
    reset,
    getValues,
    watch,
  };

  return <PageProvider {...data}>{props.children}</PageProvider>;
};
